import React from 'react';
import '../styles/Footer.css';

import InstagramIcon from '../assets/instagram.png';
import WhatsAppIcon from '../assets/whatsapp.png';

const Footer = () => {
  const instagramLink = 'https://www.instagram.com/fvs_catering/';
  const whatsappLink = 'https://api.whatsapp.com/send?phone=+521234567890';

  const handleScroll = (event, sectionId) => {
    event.preventDefault();
    const element = document.getElementById(sectionId);
    if (!element) return;
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <footer className="footer-section">
      <div className="container footer-container">
        <div className="footer-nav">
          <a href="#about" onClick={(e) => handleScroll(e, 'about')}>Sobre Nosotros</a>
          <a href="#services" onClick={(e) => handleScroll(e, 'services')}>Servicios</a>
          <a href="#gallery-accordion" onClick={(e) => handleScroll(e, 'gallery-accordion')}>Galeria</a>
          <a href="#testimonios" onClick={(e) => handleScroll(e, 'testimonios')}>Testimonios</a>
          <a href="#contacto" onClick={(e) => handleScroll(e, 'contacto')}>Contacto</a>
        </div>

        <div className="footer-social">
          <a
            className="social-link"
            href={instagramLink}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visítanos en Instagram"
            title="Instagram"
          >
            <img src={InstagramIcon} alt="Instagram" />
          </a>

          <a
            className="social-link"
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Envíanos mensaje por WhatsApp"
            title="WhatsApp"
          >
            <img src={WhatsAppIcon} alt="WhatsApp" />
          </a>
        </div>

        <p className="footer-text">
          &copy; {new Date().getFullYear()} FV Catering. Todos los derechos reservados.
        </p>
      </div>
    </footer>
  );
};

export default Footer;